import { FC } from 'react';
import Card from '@/components/ui/therapist/Card';
import { Text } from '@/components/ui/therapist/Text';
import { Button } from '@/components/ui/therapist/Button';
import { NewNavigationHighlight } from '@/components/NewNavigationHighlight';
import { View } from 'react-native';
import type { NavigationProp } from '@react-navigation/native';
import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { useNavigation } from '@react-navigation/native';
import { useNavigationHighlight } from '@/hooks/useNewNavigationHighlight';
import constants from '@/config/constants';
import { styles } from './styles';

type TemplateChoiceBannerProps = {
  type: 'word' | 'sentence';
};

export const TemplateChoiceBanner: FC<TemplateChoiceBannerProps> = ({
  type,
}) => {
  const { navigate } = useNavigation<NavigationProp<TherapistStackParamList>>();
  const enabled = constants.appVersion === '1.10.29';
  const sessionKey = 'newNavAnimationCountButton';
  const { onClickIncrement, shouldHighlight } = useNavigationHighlight({
    sessionKey,
    maxCount: 5,
    enabled,
  });

  return (
    <Card title="Inhalte aus Vorlage laden" styleBody={{ padding: 0 }}>
      <View style={styles.container}></View>

      <View style={styles.content}>
        <Text>
          Erstellen Sie ein neues Set ganz einfach auf Basis einer Vorlage.
        </Text>
        <NewNavigationHighlight
          enabled={enabled ? shouldHighlight : false}
          position="left"
        >
          <Button
            look="secondary"
            onPress={() => {
              navigate('TemplateSelect', { type });
              onClickIncrement();
            }}
            label="Vorlage auswählen"
          />
        </NewNavigationHighlight>
      </View>
    </Card>
  );
};
